export var UserType;
(function (UserType) {
    UserType[UserType["Admin"] = 0] = "Admin";
    UserType[UserType["Customer"] = 1] = "Customer";
    UserType[UserType["Supplier"] = 2] = "Supplier";
    UserType[UserType["Partner"] = 3] = "Partner";
    UserType[UserType["White_Label"] = 4] = "White_Label";
})(UserType || (UserType = {}));
